// extracted by mini-css-extract-plugin
export default {"container":"rA-z","dimension":"sA-z","dimensionLabels":"tA-z"};